var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 538.339 669.774"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__a",
    x1: 0.031,
    x2: 0.926,
    y1: 0.682,
    y2: 0.169,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8dee2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__b",
    x1: 0.07,
    x2: 0.901,
    y1: 0.498,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1b2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.453
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2274.961 303.9s110.968-93.89 150.687-140.891c56.686-67.015 84.916-269.891 68.4-355.965L-2274.961-253l-219.084 60.113c-16.519 86.008 11.712 288.884 68.4 355.9 39.718 46.999 150.684 140.887 150.684 140.887",
    style: {
      fill: "url(#shield_svg__a)"
    },
    transform: "translate(2544.133 309.371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2295.292 233.3c-33.425-29.289-93.187-82.77-117.9-111.929-40.876-48.344-69.476-206.579-63.351-297.4l.273-4.065 184.762-50.723 184.765 50.657.273 4.063c6.125 90.815-22.476 249.038-63.348 297.376-26.386 31.226-91.254 88.749-117.919 112.03l-3.776 3.3Z",
    style: {
      fill: "#00a1b2"
    },
    transform: "translate(2560.685 326.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2294.021 226.4c-38.117-33.4-93.756-83.537-117.312-111.324-40.077-47.4-67.951-205.123-62.008-293.313l179.32-49.228 179.319 49.16c5.945 88.19-21.952 245.912-62.008 293.291-23.577 27.896-79.19 78.125-117.311 111.414",
    style: {
      fill: "url(#shield_svg__b)"
    },
    transform: "translate(2563.192 329.166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2405.775 126.71c-.323-.355-.639-.7-.953-1.056a248 248 0 0 1-4.594-5.242c-40.876-48.344-69.476-206.579-63.351-297.4l.274-4.065 176.726-48.516-177.866 44.369-2.945.809-.206 3.046-.275 4.065c-6.174 91.589 22.89 251.424 64.358 300.469 8.457 9.977 38.164 33.469 38.164 33.469-11.239-10.874-21.407-21.184-29.332-29.948",
    style: {
      fill: "#f4f4f8"
    },
    transform: "translate(2558.81 327.532)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-2230.081 415.6s133.224-112.721 180.91-169.15c68.055-80.456 101.948-324.022 82.115-427.36L-2230.081-253l-263.025 72.17c-19.833 103.258 14.06 346.824 82.117 427.281 47.689 56.426 180.908 169.149 180.908 169.149Z",
    style: {
      fill: "none",
      stroke: "#fff",
      opacity: 0.303
    },
    transform: "translate(2499.253 253.521)"
  }));
};
export default SvgShield;